import React from 'react';

const NoAccess: React.FC = () => {
    return (
        <div className='flex justify-center items-center w-full h-screen text-neutral-25'>
            <p className='text-neutral-25 text-lg font-bold'>You do not have access to the Determine portal. Please contact administrator.</p>
        </div>
    );
};

export default NoAccess;